import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addToCart } from "../../redux/features/cart/cartSlice";
// import Rating from "react-rating";/
import { BiHeart } from "react-icons/bi";

import StarRatings from "react-star-ratings";
import {
  addAndRemoveWishList,
  getWishList,
} from "../../redux/features/product/productSlice";

import { BsHeartFill } from "react-icons/bs";
const ProductCard = ({
  name,
  id,
  price,
  image,
  description,
  ratings,
  numOfReviews,
}) => {
  const { wishList } = useSelector((state) => state.products);
  const dispatch = useDispatch();
  const [isFavourite, setIsFavourite] = useState(false);

  useEffect(() => {
    setIsFavourite(wishList.find((item) => item._id === id));
  }, [dispatch, wishList]);

  const addTocartHanlder = () => {
    dispatch(
      addToCart({
        name: name,
        id: id,
        price: price,
        image: image,
        description: description,
        quantity: 1,
      })
    );
  };

  const addToWishList = (id) => {
    dispatch(addAndRemoveWishList(id));
    setIsFavourite(!isFavourite);
  };
  return (
    <div className=" relative  bg-white flex flex-col m-[8px] md:m-5 font-sans shadow-sm hover:shadow-lg  rounded-lg min-w-[200px] max-w-[250px]s overflow-hidden">
      <button
        onClick={() => addToWishList(id)}
        className=" absolute  top-1 right-1 z-20 bg-slate-100 rounded-full  p-2"
      >
        {isFavourite ? (
          <BsHeartFill className=" text-orange-400" />
        ) : (
          <BiHeart className=" text-orange-400" />
        )}
      </button>

      <Link to={`/products/details/${id}`} className="pb-20">
        <div className="flex overflow-hidden justify-center items-center w-[100%] relative">
          <img
            src={`${image}`}
            alt=""
            className="transition-all duration-500   inset-0 w-full h-full object-cover hover:scale-105"
          />
        </div>
        <div className="flex justify-between px-2">
          <div>
            <div className="w-full flex-none text-sm font-medium text-green-600 mt-2">
              In stock
            </div>
          </div>
          <div>
            <div className="text-sm md:text-lg font-semibold text-slate-500">
              ${price.toFixed(2)}
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-starts px-1 mt-2">
          <div className=" flex  items-center mb-1 ">
            <StarRatings
              rating={ratings}
              starRatedColor="#FFBF00"
              // changeRating={this.changeRating}
              numberOfStars={5}
              name="rating"
              starDimension="20px"
              starSpacing="3px"
            />
            <span className=" ml-2">({numOfReviews})</span>
          </div>

          <h1 className="text-sm md:text-md font-semibold text-slate-900 hover:underline line-clamp-1">
            {name}
          </h1>
          <p className="text-gray-500 mb-1 text-sm line-clamp-2">
            {description}
          </p>
        </div>
      </Link>
      <button
        onClick={addTocartHanlder}
        className="absolute bg-[#F37613] hover:bg-[#cb6716] transition-all duration-500 my-5 text-center self-center px-5 py-2 rounded text-white w-[90%] bottom-0"
      >
        Add to Cart
      </button>
    </div>
  );
};

export default ProductCard;
